import React, { useEffect, useState } from "react";
import "../StuStyles/LiveEvents.css";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../nhrc_apis/ApiService";
import img1 from "../../../assets/jobfairs4.png";
import img2 from "../../../assets/jobFairs2.png";
import img3 from "../../../assets/JobsFairs2.png";
import img4 from "../../../assets/stu-live-program4.png";

// ✅ Fallback images cycle through if API has no image
const FALLBACK_IMAGES = [img1, img2, img3, img4];

// How many cards to show per page
const CARDS_PER_PAGE = 3;

const LiveEvents = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ─── PAGINATION STATE ───────────────────────────────────
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchJobFairs = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await ApiService.JobFairAPI.getStudentJobFairs();
        const data = response?.data;

        const jobFairs = Array.isArray(data)
          ? data
          : data?.job_fairs || data?.data || [];

        setEvents(jobFairs);
        setCurrentPage(1); // reset to first page whenever fresh data loads
        localStorage.setItem("jobFairCount", jobFairs.length);
      } catch (err) {
        console.error("FETCH JOB FAIRS ERROR:", err);
        setError("Failed to load job fairs. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchJobFairs();
  }, []);

  const handleRegister = (eventData) => {
    navigate("/student/Jobfairregister", { state: { event: eventData } });
  };

  // ─── PAGINATION LOGIC ───────────────────────────────────
  const totalPages = Math.ceil(events.length / CARDS_PER_PAGE);

  const startIndex = (currentPage - 1) * CARDS_PER_PAGE;
  const endIndex = startIndex + CARDS_PER_PAGE;
  const currentEvents = events.slice(startIndex, endIndex);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  // ─── INLINE STYLES FOR PAGINATION BUTTONS ────────────────
  const paginationWrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    marginTop: "24px",
    marginBottom: "24px",
  };

  const pageBtnStyle = {
    padding: "8px 20px",
    border: "none",
    borderRadius: "6px",
    backgroundColor: "#1a73e8",
    color: "#fff",
    fontWeight: "600",
    fontSize: "14px",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
  };

  const pageBtnDisabledStyle = {
    ...pageBtnStyle,
    backgroundColor: "#ccc",
    cursor: "not-allowed",
  };

  const pageInfoStyle = {
    fontWeight: "500",
    fontSize: "14px",
    color: "#333",
  };

  if (loading) {
    return (
      <div className="stu-live-events-wrapper">
        <h2 className="stu-live-events-title">Job Fairs</h2>
        <p style={{ textAlign: "center", padding: "20px" }}>Loading job fairs...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="stu-live-events-wrapper">
        <h2 className="stu-live-events-title">Job Fairs</h2>
        <p style={{ textAlign: "center", color: "red", padding: "20px" }}>{error}</p>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="stu-live-events-wrapper">
        <h2 className="stu-live-events-title">Job Fairs</h2>
        <p style={{ textAlign: "center", padding: "20px" }}>No job fairs available at the moment.</p>
      </div>
    );
  }

  return (
    <div className="stu-live-events-wrapper">
      <h2 className="stu-live-events-title">Job Fairs</h2>

      {currentEvents.map((e, i) => {
        // ✅ Use API image if available, otherwise fallback to local images cycling
        // Note: uses global index (startIndex + i) so fallback images don't repeat the same 3 every page
        const globalIndex = startIndex + i;
        const imageSrc =
          e.image || e.banner_url || e.image_url
            ? e.image || e.banner_url || e.image_url
            : FALLBACK_IMAGES[globalIndex % FALLBACK_IMAGES.length];

        return (
          <div key={e.id || globalIndex} className="stu-live-events-card">
            <div className="stu-live-events-details">
              <p><span>Job Fair Title :</span> {e.title || e.job_fair_title || "N/A"}</p>
              <p><span>Organization Name :</span> {e.organizer || e.organization_name || e.company_name || "N/A"}</p>
              <p><span>Date :</span> {e.date || e.event_date || e.start_date || "N/A"}</p>
              <p><span>Time :</span> {e.time || e.event_time || "N/A"}</p>
              <p><span>Location :</span> {e.location || e.venue || "N/A"}</p>
              <button
                className="stu-live-events-btn"
                onClick={() => handleRegister(e)}
              >
                REGISTER NOW
              </button>
            </div>

            {/* ✅ Always shows image — API image or fallback local image */}
            <img
              src={imageSrc}
              className="stu-live-events-image"
              alt="job fair"
            />
          </div>
        );
      })}

      {/* ─── PAGINATION CONTROLS ───────────────────────── */}
      {totalPages > 1 && (
        <div style={paginationWrapperStyle}>
          <button
            style={currentPage === 1 ? pageBtnDisabledStyle : pageBtnStyle}
            onClick={handlePrev}
            disabled={currentPage === 1}
          >
            ← Previous
          </button>

          <span style={pageInfoStyle}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            style={
              currentPage === totalPages
                ? pageBtnDisabledStyle
                : pageBtnStyle
            }
            onClick={handleNext}
            disabled={currentPage === totalPages}
          >
            Next →
          </button>
        </div>
      )}
    </div>
  );
};

export default LiveEvents;